import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleService } from '../../services/role.service';
import { CustomersService } from '../services/customers.service';
import { MatTableGeneratorComponent } from '../../shared/mat-table-generator/mat-table-generator.component';
import { MultiCrudDataSource } from '../../table-datasouces/multi-crud.datasource';
import { Sepa } from '../../dto/sepa';
import { FileHelper } from '../../helpers/file-helper';
import { toDateString } from '../../providers/app-date-adapter';
import { DateTableFilter } from '../../table-datasouces/date-table-filter';
import { SepasService } from '../services/sepas.service';



@Component( {
  selector: 'app-sepas',
  templateUrl: './sepas.component.html',
  styleUrls: [ './sepas.component.css' ],
} )
export class SepasComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private changeDetectorRefs: ChangeDetectorRef,
    private sepasService: SepasService,
  ) { }

  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;


  ngOnInit() {
    this.table.filters.str = this.route.snapshot.queryParamMap.get( 'search' );
  }



  dataSource = new MultiCrudDataSource( this.sepasService );

  columns = [
    { columnDef: 'token', header: 'Token', cell: ( row: Sepa ) => `${ row.token || '' }` },
    { columnDef: 'date', header: 'Date', cell: ( row: Sepa ) => `${ toDateString( row.date ) || '' }` },
    { columnDef: 'amount', header: 'Amount', cell: ( row: Sepa ) => `${ row.amount || '' }` },
  ];

  search( str: string ) {
    this.table.filters.str = str;
    this.onSearch();
  }

  onSearch( isInvalid = false ) {
    if ( !isInvalid ) {
      this.table.applyFilter();
    }
  }

  editEnabled() {
    return this.roleService.hasRoles('admin');
  }

  currentUserIsAdmin(){
    return this.roleService.hasRoles('admin');
  }

  deleteEnabled() {
    return this.roleService.hasRoles('admin');
  }

  multiselectEnabled() {
    return this.roleService.hasRoles( 'admin');
  }

/*
  exportSepas() {
    const idList = this.table.selection.selected.map( d => d.id );
    this.sepasService
      .export( idList ).subscribe( result => {
        FileHelper.saveFile( result );
        this.changeDetectorRefs.detectChanges();
        this.table.refreshTable();
      } );
  }
  */
}
